import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import OneOption from "../hook-checkbox-radio/OneOption";
import OptionsDropdown from "@/app/components/common-addons-builder/common-addons-fields/hook-dropdown/options-dropdown/OptionsDropdown";
import RequiredStar from "@/app/components/lib/RequiredStar";

interface Props {
  field: IField;
  form: UseFormReturn<FieldValues, any>;
}

const HookOptionDropdown: React.FC<Props> = ({ form, field: formField }) => {
  const fConfig = formField.configurations;
  const selectedKey = form.watch(fConfig.key);
  const onChange = (key: string) => {
    const currentSelected: string[] = [...selectedKey];
    selectedKey.includes(key)
      ? currentSelected.splice(selectedKey.indexOf(key), 1)
      : currentSelected.push(key);
    return currentSelected;
  };
  return (
    <>
      {!fConfig.hideLabel && (
        <div style={{ marginBottom: -8 }}>
          <RequiredStar
            style={{ marginBottom: -8 }}
            title={fConfig.title}
            isRequired={fConfig.is_required}
          />
        </div>
      )}
      <Controller
        name={fConfig.key}
        control={form.control}
        rules={{}}
        render={({ field }) => (
          <OptionsDropdown
            title={selectedKey
              ?.map(
                (key: any) =>
                  formField.data[formField.data.findIndex((o) => o.key === key)]
                    ?.value,
              )
              .join(", ")}
            isMulti
          >
            {formField.data?.map((item) => (
              <OneOption
                key={item.key}
                checked={selectedKey?.includes(item.key)}
                is_multi_select={true}
                toggleOption={() => field.onChange(onChange(item.key))}
                label={item.value}
              />
            ))}
          </OptionsDropdown>
        )}
      />
    </>
  );
};

export default HookOptionDropdown;
